import { render } from "./SanityImage.vue?vue&type=template&id=3575140e"
import script from "./SanityImage.vue?vue&type=script&lang=js"
export * from "./SanityImage.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__